export default function AdminMetricsPage() {
  return (
    <div>
      <h2 className="text-2xl font-bold text-gray-900">Métriques</h2>
      <p className="mt-4 text-gray-600">Les métriques opérationnelles seront affichées ici.</p>
    </div>
  );
}
